import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { UiFormComponent } from './ui-form.component';
import { ExtensionModule } from './extension/extension.module';
import { ValidationModule } from './validation/validation.module';

@NgModule({
  declarations: [UiFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(),
    ValidationModule,
    ExtensionModule,
  ],
  exports: [UiFormComponent],
})
export class UiFormModule {}
